import React from "react";
import { MetroSpinner } from "react-spinners-kit";
export default function Spinner() {
  return (
    <div
      style={{
        width: "100%",
        height: "80vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center"
      }}
    >
      <MetroSpinner size={70} color="blue" loading={true} />
    </div>
  );
}
